import { render, staticRenderFns } from "./LearningActivityEdit.vue?vue&type=template&id=12f245d0&scoped=true&"
import script from "./LearningActivityEdit.vue?vue&type=script&lang=js&"
export * from "./LearningActivityEdit.vue?vue&type=script&lang=js&"
import style0 from "./LearningActivityEdit.vue?vue&type=style&index=0&id=12f245d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f245d0",
  null
  
)

export default component.exports